<template>
  <div class = 'q-draw'>
    <Drawer
      :title="drawerTitle"
      v-model="qDrawerShow"
      :footer-hide="true"
      :mask-closable="false"
      @on-close="_onDrawerClose"
      className="questionCustomDrawerStyle"
      width="400"
      :styles="styles"
    > 
      <div class = 'box' style = 'height:100%;' >
        <div style = 'padding-bottom:85px;height:100%'>
          <div style = 'padding:20px 36px 0; 36px;overflow-y:auto;height:100%;'>
            <div v-show= "!tparams.isPreview" style = 'padding-bottom:20px;'>
              <div style = 'padding-bottom:5px;'>
                <span style = 'color:red;'>*</span>
                问卷类型
              </div>
              <Select not-found-text = "暂无业务类型，请联系相关人员" @on-change = 'busTypeChange'  v-model= "busType">
                <Option :value = 'item.sbtId' v-for = '(item,index) in selectList' :key = 'index'>
                  {{item.sbtName}}
                </Option>
              </Select>
            </div>
            <CQuestionnaire
              ref = 'question'
              :moId = 'tparams.moId'
              :mtId = 'tparams.mtId'
              :busType = 'tparams.busType'
              :tenantId = 'tparams.tenantId'
              :businessKey = 'tparams.businessKey'
              :isPreview = 'tparams.isPreview'
              :isVertical = 'true'
              :defaultValue = 'tparams.params'
              v-if = 'qDrawerShow&&tparams.moId&&busType'
            />
          </div>
        </div>
        <div
            class="button-drawer-footer"
            style="position:fixed;width:400px;right:0;bottom:0;left: inherit;z-index:999;"
            v-if = '!busType||isAdd&&tparams.moId&&!tparams.isPreview'
          >
          <Button @click="_onDrawerClose">取消</Button>
          <Button @click="_reset" style="margin-left:10px">重置</Button>
          <Button type="primary" @click="_save" style="margin-left:10px">提交</Button>
        </div>
      </div>
    </Drawer>
    <Drawer
      :title="drawerTitle"
      v-model="drawerShow"
      :mask-closable="false"
      className="questionCustomDrawerStyle"
      width="400"
    >
      <div style = 'padding:20px 36px 10px 36px;'>
        <div style = 'padding-bottom:5px;'>
          <span style = 'color:red;'>*</span>
          问卷类型
        </div>
        <Select @on-change = 'busTypeChange'  v-model= "busType">
          <Option :value = 'item.sbtId' v-for = '(item,index) in selectList' :key = 'index'>
            {{item.sbtName}}
          </Option>
        </Select>
      </div>
      <div
        class="button-drawer-footer"
        style="position:fixed;width:400px;right:0;bottom:0;left: inherit;"
      >
        <Button @click="drawerShow = false">取消</Button>
        <Button @click="reset" style="margin-left:10px">重置</Button>
        <Button type="primary" @click="_checkQuestionType" style="margin-left:10px">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
export default {
  data(){
    return {
      drawerTitle: '问卷调查',
      drawerShow: false,
      qDrawerShow: false,//问卷抽屉
      isAdd: false,//是否新增
      selectList: [],
      busType: '',
      tparams: {
        moId: '',
        mtId: '',
        busType: '',
        tenantId: '',
        businessKey: '',
        isPreview: false,
        params: {}
      }
    }
  },
  created(){
    this.bindEvent()
  },
  methods: {
    _reset(){
      this.$refs['question']._reset()
    },
    _save(){
      let promise = this.$refs['question']._save(this.tparams.params)
      if(promise){
        promise.then((data)=>{
          this.$Message.success('保存成功')
          this.qDrawerShow = false
          this.cbSuccess&&this.cbSuccess(data)
          this.init()
        }).catch((e)=>{
          this.$Message.error('问卷保存失败')
          this.cbError&&this.cbError(e)
        })
      }
      
    },
    bindEvent(){
      this.$eventBus.on('call_questionnaire',(data) => {
        console.log('调用问卷',data)
        this.qDrawerShow = true
        this.cbSuccess = null
        this.cbError = null
        if(data.success){
          this.cbSuccess = data.success
        }
        if(data.error){
          this.cbError = data.error
        }
        if(data&&data.custNum){
          this.custNum = data.custNum
        }
        if(data.data){
          this.tparams.params = data.data
        }
        if(data&&data.businessKey){
          this.getMoIdByBus(data.businessKey)
        }else{
          //不传businessKey默认新增
          this.isAdd = true
        }
        this.getSelectList()
      })
      this.$eventBus.on('close_questionnaire',(data) => {
        this.qDrawerShow = false
      })
    },
    _onDrawerClose(){
      this.qDrawerShow = false
      this.init()
      this.isAdd = false
    },
    getObjectId(cb) {
      let resourceTname = {}
      resourceTname.objectTname = 'scmd_ask_info_'+ JSON.parse(localStorage.user).info.tenantId;
      resourceTname.objectState = '1';
      this.$http
        .get("/scmd/Object/baseGetObject", {
          params: resourceTname
        })
        .then(response => {
          if (response.data.returnCode === 0) {
            this.objectId = response.data.beans[0].moId;
            cb&&cb(this.objectId)
          } else {
            this.objectId = ""
          }
        })
    },
    //获取问卷业务类型
    getSelectList(moId){
      this.$http.get(`/scmd/objBusType//getBusTypeListByPermission`).then(({data}) => {
        if(data.returnCode == 0){
          this.selectList = data.bean.busTypeList
          this.busType = data.bean.selected
          this.busTypeChange(this.busType)
        }else{
          this.$Message.error('获取问卷业务类型失败')
        }
      })
    },
    //选择问卷类型提交(另一种逻辑)
    _checkQuestionType(){
      if(!this.busType){
        this.$Message.error('请选择业务类型')
        return
      }
      let {selectList} = this
      for(let i in selectList){
        if(selectList[i].sbtId == this.busType){
          this.tparams.moId = selectList[i].moId
          this.tparams.busType = this.busType
          this.drawerShow = false
          this.$nextTick(()=>{
            this.qDrawerShow = true
          })
          return
        }
      }
    },
    busTypeChange(value){
      console.log('选择业务类型',value)
      let {selectList} = this
      for(let i in selectList){
        if(selectList[i].sbtId == value){
          this.tparams.moId = selectList[i].moId
          this.tparams.busType = value
          return
        }
      }
    },
    getMoIdByBus(key){
      var tenantId = this.tenantId
      var mtId = this.mtId
      var params = {
        Head: {
          method: 'select',
          version: 'v1.0'
        },
        Data: [
          {
            optionType: "update",
            moId: this.moId,
            OBJECT_NAME: "scmd_ask_info_"+JSON.parse(localStorage.user).info.tenantId,
            whereOf: `is_delete =0  and business_key =${key}`,
            operFields: "*",
            page: {
              pageNumber: 1,
              pageSize: 10
            }
          }
        ]
      }
      this.$http.post(`/sccm/custom/operCustom`,params).then(({data}) => {
        if(data.returnCode == 0){
          if(data.beans.length){
            let value = data.beans[0]
            this.tparams.moId = value.mo_id
            this.tparams.mtId = value.mt_id
            this.tparams.businessKey = value.business_key
            this.tparams.busType = value.business_type
            this.tparams.tenantId = value.tenant_id
            this.tparams.isPreview = true
            this.busType = value.business_type
          }else{
            this.tparams.businessKey = key
            this.isAdd = true
          }
        }
      })
    },
    //重置变量
    init(){
      this.tparams = {
        moId: '',
        mtId: '',
        busType: '',
        tenantId: '',
        businessKey: '',
        isPreview: false,
        params: {}
      }
      this.busType = ''
      this.isAdd = false
    }
  }
}
</script>

<style lang = 'less'>
.questionCustomDrawerStyle .ivu-drawer-body{
  padding:0!important;
}
</style>